
import React, { Component } from 'react';
import UrlServer from "configs/UrlServer"
import { APIPost, APIGet } from "services/APIRequest"
import * as Alert from "alertService"
import * as ChartModuleMore from 'highcharts/highcharts-more.js';
import HCSoldGauge from 'highcharts/modules/solid-gauge';
import Highcharts from 'highcharts'
ChartModuleMore(Highcharts);
HCSoldGauge(Highcharts);

class Chart extends Component {
	constructor() {
		super();
		this.state = {
			data: null
		}
	}
	componentDidMount() {
		Alert.Loading(true)
		APIPost(UrlServer.URL_GET_GENERATEREPORTS_GET_DATA_DASHBOARD3_OS3, { quarter: this.props.cerrent_quarter, dealer_code_list: this.props.dealer_code_list }, ({ datas }) => {
			this.setState({
				data: datas
			}, () => {
				Alert.LoadingClose()
				this.setChart(datas)
			})
		})
	}
	setChart(datas) {
		var categories = []
		var val_set = []
		var _datas = datas.sort(function (a, b) { return parseFloat(b.avg) - parseFloat(a.avg) });
		_datas.map((row) => {
			categories.push(row.name + " ( N:" + row.count + " )")
			val_set.push(parseFloat(row.avg))
			// series.push({
			// 	name: row.name,
			// 	data: [parseFloat(row.avg)]
			// })
		})
		var series = [
			{
				name: 'Quarter : ' + this.props.cerrent_quarter + this.props.cerrent_quarter + " / " + (this.props.cerrent_quarter == 2 || this.props.cerrent_quarter == 3 ? "21" : "22") + " / " + this.props.cerrent_area,
				data: val_set
			}
		]
		Highcharts.chart('chart_2_1_l3', {
			chart: {
				type: 'bar'
			},
			title: {
				text: 'Quarter : ' + this.props.cerrent_quarter + " / " + (this.props.cerrent_quarter == 2 || this.props.cerrent_quarter == 3 ? "21" : "22") + " / " + this.props.cerrent_area
			},
			subtitle: {
				text: 'Number of ' + (_datas ? _datas.length : 0) + ' branches'
			},
			xAxis: {
				categories: categories,
				title: {
					text: null
				}
			},
			yAxis: {
				min: 0,
				max: 10,
				title: {
					text: '',
					align: 'high'
				},
				labels: {
					overflow: 'justify'
				}
			},
			tooltip: {
				valueSuffix: ' '
			},
			plotOptions: {
				bar: {
					dataLabels: {
						enabled: true
					}
				},
			},
			// legend: {
			// 	layout: 'vertical',
			// 	align: 'right',
			// 	verticalAlign: 'top',
			// 	x: -40,
			// 	y: 0,
			// 	floating: true,
			// 	borderWidth: 1,
			// 	backgroundColor:
			// 		Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
			// 	shadow: true
			// },
			credits: {
				enabled: false
			},
			series: series
		});
	}
	render() {
		return (
			<div className={"chart-box"}>
				<center>
					<div id="chart_2_1_l3" style={{ width: "94%", height: "650px" }}></div>
				</center>
			</div>
		);
	}
}

export default Chart;